module.exports = __webpack_public_path__ + "img/patner.614f75d9.png";